




























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'
import {maxLength, required} from "vuelidate/lib/validators";
import {Validations} from 'vuelidate-property-decorators';
import axios from "axios";
import {getHeaderHeight} from "@/services/margin";

@Component
export default class getBrochureBuminator extends Vue {
  @Prop() isMobileView!: boolean;
  public disabledForm = false
  public isSendedMail = false
  public isShowForm = false
  public route = '/bauminator/getBrochure'
  public formData = {
    email: '',
    country: '',
    continent: '',
    checkbox: '',
  }
  mobilTopMargin = 0;


  mounted(){
    if(this.isMobileView){
      this.mobilTopMargin = getHeaderHeight() + 30
    }
  }

  validateEmail(email: any) {
    let regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!email || email.length == 0) {
      return true;
    } else {
      return regex.test(email);
    }
  };

  submit() {
    if (this.$v.formData.$invalid) {
      this.$v.formData.$touch();
    } else {
      this.disabledForm = true;
      const formData = new FormData()
      formData.append('email', this.formData.email)
      formData.append('country', this.formData.country)
      formData.append('continent', this.formData.continent)
      formData.append('checkbox', '1')

      axios.post(this.route, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        if (response.data.success) {
          this.isSendedMail = true
        } else {
          console.log('error', response)
        }
        this.disabledForm = false;
      }).catch(response => {
        this.disabledForm = false;

      })
    }
  }

  @Validations()
  validations = {
    formData: {
      email: {required, validateEmail: this.validateEmail},
      country: {required},
      continent: {required},
      checkbox: {required},
    }
  }


  trans(key: string) {
    return translate(key)
  }


}
